export enum PaymentType {
  Online,
  InSalon,
  DownPaymentOnline
}
